import { render, staticRenderFns } from "./UserRolesCurrent.vue?vue&type=template&id=53ee172c&scoped=true"
import script from "./UserRolesCurrent.vue?vue&type=script&lang=js"
export * from "./UserRolesCurrent.vue?vue&type=script&lang=js"
import style0 from "./UserRolesCurrent.vue?vue&type=style&index=0&id=53ee172c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee172c",
  null
  
)

export default component.exports